var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { Widget } from '@web/components/layout/Widget';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import Heatmap from '@web/components/ui/charts/Heatmap';
import { EXTENDED_WORK_HOURS_HEATMAP_COLORS } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { handleTimelineCellClick, isAiButtonDisabled } from '@web/utility';
import { toISODate } from '@web/utility/date';
import { useFilters } from '@web/utility/hooks/useFilters';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { format, subYears } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
export var DaysWithExtendedWorkHours = function (_a) {
    var userId = _a.userId, orgUnitId = _a.orgUnitId;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var filters = useFilters();
    var dateTo = format(new Date(), 'yyyy-MM-dd');
    var dateFrom = format(subYears(new Date(), 1), 'yyyy-MM-dd');
    var _b = trpc.daysWithExtendedWorkHours.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), data = _b.data, isLoading = _b.isLoading, refetch = _b.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    return (_jsxs("div", { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.workLifeBalanceSection.daysWithExtendedWorkHours'), description: t('widgetTitleDescriptions.workLifeBalance.daysWithExtendedWorkHours'), insightType: InsightTypeEnum.daysWithExtendedWorkHours, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.workLifeBalanceSection.daysWithExtendedWorkHours'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, (data !== null && data !== void 0 ? data : [])
                                    .filter(function (d) { return d.count > 0; })
                                    .map(function (d) {
                                    var _a;
                                    return (_a = {},
                                        _a[t('export.date')] = toISODate(new Date(d.date)),
                                        _a[t('export.activityCount')] = d.count,
                                        _a);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(data) }) }), _jsx(Widget, { children: _jsx(Heatmap, { values: data, colorIntensity: EXTENDED_WORK_HOURS_HEATMAP_COLORS, useDirectColorMatch: true, onCellClick: userId
                        ? function (value) {
                            return handleTimelineCellClick(userId, value, filters, navigate);
                        }
                        : undefined, clickable: !!userId }) })] }));
};
